import Vue from "vue";
import Component from "vue-class-component";
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate", // for vue-router 2.2+
]);
import Router from "vue-router";

// ROUTES
const Error = () => import("@/core/error/error.vue");
const Home = () => import("@/products/platform/home/home.vue");
const SetPassword = () => import("@/products/platform/set-password/set-password.vue");
const Audits = () => import("@/back-office/jhipster-old/audits/audits.vue");
const Core = () => import("@/core/core.vue");
const RGPD = () => import("@/shared/components/RGPD.vue");
const AdminDashboard = () => import("@/back-office/admin-dashboard.vue");

const OdonaPlace = () => import("@/products/platform/odona-place/odona-place.vue");

// ODO PRO Components
const MenuView = () => import("@/products/e-learning/MenuView.vue");
const ChapterOne = () => import("@/products/e-learning/chapter-one/ChapterOne.vue");
const ChapterTwo = () => import("@/products/e-learning/chapter-two/ChapterTwo.vue");
const ChapterThree = () => import("@/products/e-learning/chapter-three/ChapterThree.vue");
const Certification = () => import("@/products/e-learning/certification/Certification.vue");

Vue.use(Router);

// prettier-ignore
export default new Router({
  mode: "history",
  routes: [
    { path: "/", name: "sign-in", component: Home },
    { path: "/set-password/:id", name: "set-password", component: SetPassword },
    { path: "/audits", name: "audits", component: Audits },

    { path: "/core", component: Core },
    { path: "/core/:action", component: Core },
    { path: "/core/:action/:id", component: Core },

    { path: "/politics", name: "Page de RGPD", component: RGPD },

    // ODO PRO
    { path: "/odopro/menu", name: "Menu OdonaLEA", component: MenuView, meta: { authorities: ["ROLE_USER"] } },
    {
      path: "/odopro/chapter-one",
      name: "Chapitre 1 OdonaLEA",
      component: ChapterOne,
      meta: { authorities: ["ROLE_USER"] },
    },
    {
      path: "/odopro/chapter-two",
      name: "Chapitre 2 OdonaLEA",
      component: ChapterTwo,
      meta: { authorities: ["ROLE_USER"] },
    },
    {
      path: "/odopro/chapter-three",
      name: "Chapitre 3 OdonaLEA",
      component: ChapterThree,
      meta: { authorities: ["ROLE_USER"] },
    },
    {
      path: "/odopro/certification",
      name: "Certification OdonaLEA",
      component: Certification,
      meta: { authorities: ["ROLE_USER"] },
    },
    { path: "/platform", name: "Accueil", component: OdonaPlace, meta: { authorities: ["ROLE_USER"] } },

    //OAUTH2.0
   
    { path: "/admin", component: AdminDashboard, meta: { authorities: ["ROLE_ADMIN"] } },
  ],
});
